import { Modal, Button, Divider } from "antd";
import * as React from "react";
import {
  Layout,
  Input,
  TimePicker,
  Select,
  notification,
  DatePicker,
  Spin,
} from "antd";
import { Formik, FieldProps, Field } from "formik";
const { Content } = Layout;

export class PaidForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      data: [],
      view: false,
      isLoading: false,
      visible: false,
    };
  }

  validateForm = (values) => {
    const errors = {};

    if (!values.amount) {
      errors.amount = "Amount is required";
    }

    if (!(values.amount >= 0)) {
      errors.amount = "Amount can not be negative";
    }

    if (!values.transaction_number) {
      errors.transaction_number = "Transaction number is required";
    }

    if (!values.invoice_number) {
      errors.invoice_number = "Invoice number is required";
    }

    if (!values.po_number) {
      errors.po_number = "PO number is required";
    }

    return errors;
  };

  handleSubmit = (values, action) => {
    try {
      this.props.onSubmit(values, this.props.data.id);
      this.props.handleCancel();

      this.setState({
        visible: false,
      });
      this.handleCancel();
    } catch (e) {
      console.log("!!!!error", e);
    }
  };

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = () => {
    this.setState({
      visible: false,
    });
  };

  handleCancel = () => {
    this.setState({
      visible: false,
    });
  };

  render() {
    const { isLoading } = this.state;

    return (
      <div>
        <div>
          <Content style={{ background: "#fff", marginLeft: "10px" }}>
            <Formik
              initialValues={{
                amount: 0,
                transaction_number: "",
                invoice_number: "",
                po_number: "",
              }}
              validate={this.validateForm}
              onSubmit={this.handleSubmit}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                setFieldTouched,
                isSubmitting,
              }) => {
                return isLoading ? (
                  <div style={{ marginLeft: "20px" }}>
                    <Spin
                      size="large"
                      style={{ width: "100%", margin: "0 auto" }}
                    />
                  </div>
                ) : (
                  <div>
                    <div className="formik-field_wrap">
                      <div className="formik-field-left">
                        Amount ( $ )
                        <Input
                          id="amount"
                          type={"number"}
                          placeholder="Amount"
                          value={values.amount}
                          onChange={handleChange}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              handleSubmit();
                            }
                          }}
                          onBlur={handleBlur}
                        />
                        {errors.amount && touched.amount ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {errors.amount}
                          </p>
                        ) : null}
                      </div>
                      <div className="formik-field-right">
                        Invoice Number
                        <Input
                          id="invoice_number"
                          placeholder="Invoice Number"
                          value={values.invoice_number}
                          onChange={handleChange}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              handleSubmit();
                            }
                          }}
                          onBlur={handleBlur}
                        />
                        {errors.invoice_number && touched.invoice_number ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {errors.invoice_number}
                          </p>
                        ) : null}
                      </div>
                    </div>

                    <div className="formik-field_wrap">
                      <div className="formik-field-left">
                        Transaction Number
                        <Input
                          id="transaction_number"
                          placeholder="Transaction Number"
                          value={values.transaction_number}
                          onChange={handleChange}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              handleSubmit();
                            }
                          }}
                          onBlur={handleBlur}
                        />
                        {errors.transaction_number &&
                        touched.transaction_number ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {errors.transaction_number}
                          </p>
                        ) : null}
                      </div>
                      <div className="formik-field-right">
                        PO Number
                        <Input
                          id="po_number"
                          placeholder="PO Number"
                          value={values.po_number}
                          onChange={handleChange}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              handleSubmit();
                            }
                          }}
                          onBlur={handleBlur}
                        />
                        {errors.po_number && touched.po_number ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {errors.po_number}
                          </p>
                        ) : null}
                      </div>
                    </div>

                    <Button
                      type="primary"
                      style={{
                        marginTop: "19px",
                        background: "#5C6AC4",
                        color: "#fff",
                      }}
                      onClick={handleSubmit}
                    >
                      Pay
                    </Button>
                  </div>
                );
              }}
            </Formik>
          </Content>
        </div>
      </div>
    );
  }
}
